import { DemoExResponse } from "src/services/admin/queries/NetTypes";

import CreatedAt from "./Cells/CreatedAt";
import Empty from "./Cells/Empty";

type Col = {
	id: string;
	Cell: (demo: DemoExResponse) => JSX.Element | null;
	align?: "center" | "left";
};

const cols: Col[] = [
	{
		id: "createdAt",
		Cell: CreatedAt,
		align: "left"
	},
	{
		id: "entity",
		Cell: Empty,
		align: "center"
	},
	{
		id: "status",
		Cell: Empty,
		align: "center"
	}
];

export default cols;
